import React, { useDebugValue } from "react";
import { Col, Row } from "react-bootstrap";
import { BsBuildingsFill } from "react-icons/bs";
import { FaFileContract, FaFileInvoiceDollar, FaSwimmingPool } from "react-icons/fa";
import { MdCreate, MdEmergency, MdOutlineDone, MdOutlineOilBarrel, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbCoins, TbFileUnknown, TbFlame, TbTruckDelivery } from "react-icons/tb";
import { useAuthState } from "../../context/AuthContext";
import energoLogo from '../../color-logo.svg';

/**
 * 
 * @param {created} props bool if ticket status should be about creation
 * @param {creator} props string used only if bool created is true to decide is custoemr or energo
 * @param {closed} props bool if ticket status shoulb be about closing
 * @param {building} props bool if ticket is about building
 * @param {anlage} props bool if ticket is about anlage
 * @param {elv} props bool if ticket is about elv
 * @param {invoice} props bool if ticket is about invoice
 * @param {ticket} props object selected ticket
 * @param {data} props object
 */
const TicketStatus = ({creator, type, data, ticket, elv}) => {

    const {user} = useAuthState();

    return (
        <div className={type === 'closed' ? "ticket-info-content-closed mt-3": "ticket-info-content mt-3"}>
            <Row className="align-items-center">
                <Col xs="12" md="1" xl="1">
                    <div 
                        className={
                            `circle-icon 
                            ${
                                type === 'created' ? 
                                    creator === 'customer' ? 'text-inverse border-inverse' : 'text-energo border-energo':
                                type === 'closed' ? 'text-energo border-energo' :
                                type === 'building' ? 'text-dark border-dark' :
                                type === 'elv' ? 'text-primary border-primary' :
                                type === 'anlage' ? 
                                    data['Anlage Energieform'] === "Strom" ? 'text-energo border-energo' :
                                    data['Anlage Energieform'] === "Gas" ? 'text-cyan border-cyan' :
                                    data['Anlage Energieform'] === "Oil" ? 'text-danger border-danger' :
                                    data['Anlage Energieform'] === "Strom-Einspeisung" ? 'text-warning border-warning' :
                                    'text-dark border-dark' :
                                type === 'invoice' ?
                                    data['Rechnung von'] !== undefined && data['Rechnung von'] === "ENERGO"? 'text-energo border-energo':
                                    data['Rechnung von'] !== undefined && data['Rechnung von'] === "Energielieferant"? 'text-primary border-primary':
                                    data['Rechnung von'] !== undefined && data['Rechnung von'] === "Unbekannt"? 'text-warning border-warning':
                                    " " :
                                type === 'missingInvoice' ? 'text-warning border-warning' :
                                type === 'paymentChange' ? 'text-violet border-violet' :
                                type === 'emergency' ? 'text-danger border-danger' :
                                null
                            }
                            `
                        }
                    >
                        {
                            type === 'created' ? <MdCreate size={40} /> :
                            type === 'closed' ? <MdOutlineDone size={40} /> :
                            type === 'building' ? <BsBuildingsFill size={40} /> :
                            type === 'elv' ? <FaFileContract size={40} /> :
                            type === 'anlage' ?
                                data['Anlage Energieform'] === "Strom" ? <SlEnergy size={40} /> :
                                data['Anlage Energieform'] === "Gas" ? <TbFlame size={40} /> :
                                data['Anlage Energieform'] === "Oil" ? <MdOutlineOilBarrel size={40} /> :
                                data['Anlage Energieform'] === "Strom-Einspeisung" ? <MdOutlineSolarPower size={40} /> :
                                null :
                            type === 'invoice' ?
                                data['Rechnung von'] !== undefined && data['Rechnung von'] === "ENERGO"? <img src={energoLogo} width={41} height={40} /> :
                                data['Rechnung von'] !== undefined && data['Rechnung von'] === "Energielieferant"? <TbTruckDelivery size={40}/> :
                                data['Rechnung von'] !== undefined && data['Rechnung von'] === "Unbekannt"? <TbFileUnknown size={40}/> :
                                null :
                            type === 'missingInvoice' ? <TbFileUnknown size={40} /> :
                            type === 'paymentChange' ? <TbCoins size={40} /> :
                            type === 'emergency' ? <MdEmergency size={40} /> :
                            null
                        }
                    </div>
                </Col>
                <Col xs="12" md="11" xl="11">
                    {
                        type === 'created' ? 
                            <small className="text-muted">
                                <b style={creator === 'customer' ? {color: '#c13fa3'}:{color: 'a2c13f'}}>Ticket erstellt</b>&nbsp;
                                am {new Date(ticket.create_date).toLocaleDateString('DE-de')}&nbsp;
                                von <span style={creator === 'customer' ? {color: '#c13fa3'}:{color: 'a2c13f'}}>
                                    {user.name !== ticket.partner_id[1] && ticket.partner_id[1].includes(user.name) ? ticket.partner_id[1].replace(`${user.name}, `, "") : ticket.partner_id[1]}
                                </span>
                            </small> :

                        type === 'closed' ?
                            <small>
                                <b className="text-energo">Ticket erledigt</b>
                                {ticket.description.includes('Ticket durch Benutzer geschlossen') ? 
                                    <span className="text-muted"> durch Benutzer geschlossen.</span> : '.'
                                }
                            </small> :

                        type === 'building' ?
                            <small className="text-muted">
                                Liegenschaft&nbsp;
                                <span className="text-dark">{data['Gebäude Straße']}, {data['Gebäude PLZ']}</span>
                            </small> :
                        
                        type === 'elv' ? 
                            <small className="text-muted">
                                Energieliefervertrag&nbsp;
                                <a 
                                    href={`/${user.x_is_house_management? 'hw/':''}dashboard/energieliefervertraege/${ticket.x_support_elv_id[0]}`} 
                                    className="link-energo text-primary">{ticket.x_support_elv_id[1]}</a>
                            </small> :

                        type === 'anlage' ?
                            <small className="text-muted">
                                Anlage mit ENERGO Anlagennummer&nbsp;
                                <span className={
                                    data['Anlage Energieform'] === "Strom" ? 'text-energo' :
                                    data['Anlage Energieform'] === "Gas" ? 'text-cyan' :
                                    data['Anlage Energieform'] === "Oil" ? 'text-danger' :
                                    data['Anlage Energieform'] === "Strom-Einspeisung" ? 'text-warning' :
                                    'text-dark border-dark' 
                                }>{data['Anlagennummer ENERGO']}
                                </span>&nbsp;
                                {data['Anlagenverwendung']}
                            </small> :

                        type === 'invoice' ?
                            data['Rechnung von'] !== undefined && data['Rechnung von'] === "ENERGO"?
                                <small className="text-muted">
                                    <span className="text-energo">ENERGO</span>&nbsp;
                                    {new Date(data['Rechnungsdatum']).toLocaleDateString('DE-de')}&nbsp;
                                    mit Rechnungsnummer&nbsp;
                                    <span className="text-energo">{data['Rechnungsnummer']}</span>
                                </small> :
                            data['Rechnung von'] !== undefined && data['Rechnung von'] === "Energielieferant"?
                            <small className="text-muted">
                                <span className="text-primary">Energielieferant</span>&nbsp;
                                {new Date(data['Rechnungsdatum']).toLocaleDateString('DE-de')}&nbsp;
                                mit Rechnungsnummer&nbsp;
                                <span className="text-primary">{data['Rechnungsnummer']}</span>
                            </small> :
                            data['Rechnung von'] !== undefined && data['Rechnung von'] === "Unbekannt"?
                            <small className="text-muted">
                                <span className="text-warning">Unbekannt</span>&nbsp;
                                mit Rechnungsnummer&nbsp;
                                <span className="text-warning">{data['Rechnungsnummer']}</span>
                            </small> :
                            data['Rechnungsnummer'] ?
                                <small className="text-muted">
                                    <span className="text-energo">ENERGO</span>&nbsp;
                                    {data['Rechnungsart']} {data['Rechnungsdatum']}&nbsp;
                                    mit Rechnungsnummer&nbsp;
                                    <span className="text-energo">{data['Rechnungsnummer']}</span>
                                </small> :
                            data['Rechnungsart'] === 'Vorschreibung' ?
                                <small className="text-muted">
                                    Vorschreibung&nbsp;
                                    <span className="text-warning">{data['Rechnungsdatum']}</span>
                                </small> :
                            data['Eingangsdatum'] ?
                                <small className="text-muted">
                                    Energielieferant&nbsp;
                                    <span className="text-primary">{data['Rechnungsart']}</span>&nbsp;
                                    {data['Rechnungsdatum']}
                                </small> : null :
                        
                        type === "missingInvoice" ?
                                <small className="text-muted">
                                    Fehlende Abrechnung&nbsp;
                                    <span className="text-warning">{data['Fehlende Abrechnung']}</span>
                                </small> :

                        type === 'paymentChange' ?
                            <small className="text-muted">
                                Teilvorschreibungsbetrag von&nbsp;
                                {data['Aktueller Betrag']} auf {data['Gewünschter Betrag']} ändern
                            </small> :

                        type === 'emergency' ?
                            <small className="text-danger"><b>Notfall-Ticket</b></small>

                        :null
                    }
                </Col>
            </Row>
        </div>
    )
}

export default TicketStatus;